import React, { memo } from "react";
import { useAppContext } from "../hooks/useAppContext";
import { FeaturesScreen } from "../screens/features";
import { MainScreen } from "../screens/main";

export const Router = memo(function Router() {
	const { platform } = useAppContext();

	switch (platform.queryString.getQueryStringParameter("screen")) {
		case "features":
			return <FeaturesScreen />;
		default:
			return <MainScreen />;
	}
});
Router.displayName = "Router";
